<template>
  <home-floating-window
    :title="$tc('MultiPointRouting')"
    @close="closeCluster"
    @changePosition="$emit('changeClusterWindowsPosition', $event)"
    :pos-x="position.x"
    :pos-y="position.y"
    :draggable="!loading"
  >
    <template v-slot:iconWindows>
      <ClusterToolSVG class="floating-container-svg" />
    </template>

    <template v-slot:objectDivWindows>
      <div class="floating-tool-content" style="width: 250px">
        <div class="cluster-objects-div">
          <cluster-selection-type-buttons
            :selection-type="clusterTool.type ? clusterTool.type : 'polygon'"
            :creatable="clusterTool.creatable"
            @setType="setClusterType"
            :clusterTool="true"
          />

          <cluster-selected-objects
            v-if="clusterToolWKT"
            :selectedObjects="clusterToolWKT"
            selectionType="polygon"
            :clusterTool="true"
            @openObjectMenu="openClusterObjectMenu($event.event, $event.object)"
          />
          <HighlightedBox
            :bad-object="badObject"
            :is-visible="showInstruction"
            :message="currentInstruction"
          />
        </div>

        <window-object-menu
          v-if="clusterObjectMenu.open"
          :event="clusterObjectMenu.event"
          :object="clusterObjectMenu.object"
          :actionFrom="selectedToolObjectLayer"
          @updateGeoServer="updateGeoServer"
          @closeMenu="closeClusterObjectMenu"
          @openForm="openFormFromClusterObjectMenu"
          @openDetailForm="openFormFromClusterObjectMenu('detail')"
          v-on-clickaway="closeClusterObjectMenu"
        />
        <home-window-button
          :label="$t('Create')"
          @buttonClick="saveCluster"
          :disabled="!clusterToolButtonDisabled"
        />
      </div>
      <cluster-closure-selection
        v-if="openClosureSelection"
        :closure-options="polygonClosures"
        @submit="previewFromClosureSelection"
        @close="closeMultipleClosure"
      />
    </template>
  </home-floating-window>
</template>
<script>
import HomeFloatingWindow from "../HomeFloatingWindow";
import ClusterClosureSelection from "@/components/Home/Content/ObjectWindow/Cluster/ClosureSelection";
import HomeWindowButton from "../../HomeWindowButton";
import ClusterToolSVG from "@/assets/cluster_tool_svgs/clusterTool.svg";
import ClusterSelectionTypeButtons from "@/components/Home/Content/ObjectWindow/Cluster/SelectionTypeButtons";
import ClusterSelectedObjects from "@/components/Home/Content/ObjectWindow/Cluster/SelectedObjects";
import { mixin as clickaway } from "vue-clickaway";
import HighlightedBox from "@/components/_Molecules/HighlightedBox";
import { clusterOptionsMixin } from "@/mixins/clusterOptionsMixin";
import WindowObjectMenu from "../../ObjectMenu/WindowObjectMenu";
import { bus } from "@/main";
import { mapActions } from "vuex";
import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style";
import { GeoJSON } from "ol/format";

export default {
  name: "clusterToolWindow",

  components: {
    HomeFloatingWindow,
    ClusterSelectionTypeButtons,
    ClusterToolSVG,
    HighlightedBox,
    ClusterSelectedObjects,
    HomeWindowButton,
    WindowObjectMenu,
    ClusterClosureSelection
  },

  mixins: [clickaway, clusterOptionsMixin],

  props: {
    clusterTool: {
      type: Object
    },
    vectorSource: {},
    position: Object
  },
  data() {
    return {
      loading: false,
      badObject: false,
      dataSaveCluster: {
        initial_closure: 2,
        end_closure: 1,
        start_closure: "uuid"
      },
      clusterObjectMenu: {
        open: false,
        event: null,
        object: null
      },
      polygonClosures: null,
      openClosureSelection: false,
      clusterToolWKT: [],
      maxPathwayDistance: 0,
      maxCableLength: 0,
      statusWorkspace: null
    };
  },
  watch: {
    clusterToolForm(value) {
      if (!value) {
        this.closeCluster();
      }
    }
  },

  computed: {
    /**
     * @returns {Boolean} - True if cable from is opened
     */
    clusterToolForm() {
      return this.$store.getters.getClusterToolForm;
    },
    /**
     * changes text based on selected tool (polygon or point)
     */
    currentInstruction() {
      let instruction = "";
      switch (this.clusterTool.type) {
        case null:
          instruction = this.$t("SelectClusterType");

          break;
        case "point":
          if (this.clusterToolWKT.length >= 0) {
            instruction = this.$t("SelectClosure");
          }
          break;
        case "polygon":
          if (this.clusterToolWKT.length === 0) {
            instruction = this.$t("DrawClusterToolPolygon");
          }
          break;
      }
      return instruction;
    },
    /**
     * disables create button if no closures are selected
     */
    clusterToolButtonDisabled() {
      return this.clusterToolWKT && this.clusterToolWKT.length >= 1;
    }
  },

  mounted() {
    /**
     * sets initial type on mount
     */
    this.clusterTool.type = "polygon";
    /**
     * receives cluster data to send to backend
     */
    bus.$on("start-cluster-by-polygon", e => this.startClusterByPolygon(e));
    /**
     * receives closure data to send to back end
     */
    bus.$on("add-new-point-to-cluster", data => {
      this.addNewPointToCluster(data.id, data.objectTypeRoute);
    });
    bus.$on("deactivate-fc_cluster_tool", () => this.closeCluster());
  },

  destroyed() {
    /**
     * turns off event transmitter
     */
    bus.$off("start-cluster-by-polygon");
    bus.$off("add-new-point-to-cluster");
    bus.$off("deactivate-fc_cluster_tool");
  },

  methods: {
    ...mapActions([
      "CLUSTER_TOOL_PREVIEW",
      "GET_OBJECTS_LAYERS_INSIDE",
      "GET_ALL_OBJECTS_IN_LAYER_WITHIN_POLYGON"
    ]),

    //closes closure selection and resets cluster tool
    closeMultipleClosure() {
      this.openClosureSelection = false;
      this.resetClusterTool(true);
    },
    /**
     * closes clusterTool window, clears the data
     */
    closeCluster() {
      this.clusterToolWKT = [];
      this.$emit("close");
    },
    /**
     * resets cluster tool data
     */
    resetClusterTool(unbindKey) {
      this.clusterToolWKT = [];
      this.$emit("resetClusterTool", unbindKey);
    },
    /**
     * sets cluster type (point or polygon)
     * clears all data when type changes
     */
    setClusterType(typeOfSelection) {
      this.clusterTool.type = typeOfSelection;
      this.resetClusterTool(true);
      this.clearDataSaveCluster();
    },
    /**
     * starts drawing mode and sends projection
     */
    startClusterByPolygon(event) {
      this.resetClusterTool(false);

      this.$emit("drawNewPolygon", event, promise => {
        promise.then(polygonWKT => {
          this.dataSaveCluster.text_geom = polygonWKT;
          this.dataSaveCluster.projection = 3857;

          this.requestSelection({
            text_geom: polygonWKT,
            projection: 3857,
            layers: ["fc_closure"]
          });
        });
      });
    },

    async requestSelection(objectToSend) {
      try {
        this.loading = true;
        let layer = await this.GET_OBJECTS_LAYERS_INSIDE(objectToSend);

        if (layer[0].layer === "fc_closure") {
          let closures = await this.GET_ALL_OBJECTS_IN_LAYER_WITHIN_POLYGON({
            endpoint: "closures",
            technicalType: undefined
          });
          this.polygonClosures = closures.filter(item => {
            if (item.cl_network_level === "2") {
              return item;
            }
          });
          if (this.polygonClosures.length <= 1) {
            this.dataSaveCluster.start_closure = this.polygonClosures[0].cl_uuid;
            this.previewCluster();
          } else {
            this.openClosureSelection = true;
          }
        } else {
          this.$toasted.global.toast_error(
            "No objects were found in the active layers."
          );
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    previewFromClosureSelection(value) {
      this.dataSaveCluster.start_closure = value;
      this.previewCluster();
    },
    /**
     * receives projection from the data sent, closures and cable are then drawn
     */
    async previewCluster() {
      try {
        let data = await this.CLUSTER_TOOL_PREVIEW(this.dataSaveCluster);

        let arr = [];
        let object = [];

        for (const objects of data) {
          delete objects.total_cable_length;

          for (const closure of objects.nodes) {
            arr.push(closure.obj);
            delete closure.pathways;

            object.push(objects);
          }
          if(Array.isArray(objects.pathways)){
            for (const pathways of objects.pathways) {
              this.addPathwayLineHighlight(pathways);
            }
          }
        }
        let closures = arr.filter(
          (v, i, a) =>
            a.findIndex(t => t.cl_id === v.cl_id && t.cl_uuid === v.cl_uuid) ===
            i
        );
        for (const closure of closures) {
          this.addNodesToClusterPreview(closure);
          this.addClosureToClusterWKT(closure);
        }
        this.dataSaveCluster.closures = object;
      } catch (err) {
        this.$toasted.global.toast_error(err.response.data.message);
        this.setClusterType("polygon");
      }
    },
    /**
     * @param data - receives data (geo_json) creates the style of drawing for specific object (closures)
     *  */

    addNodesToClusterPreview(data) {
      let cl_bd_style = new Style({
        image: new CircleStyle({
          radius: 5,
          fill: new Fill({ color: "rgba(255, 0, 0, 0.5)" }),
          stroke: new Stroke({ color: "#bada55", width: 1 })
        })
      });

      this.highlightClosure(data, cl_bd_style);
    },
    /**
     * @param data - Geo Json
     * @param style - drawing style
     * uses geo json to draw point in map
     */
    highlightClosure(data, style) {
      let closureGeoJSON = data.node.nd_geo_json;
      let features = new GeoJSON().readFeatures(closureGeoJSON, {
        featureProjection: "EPSG:3857"
      });
      let feature = features[0];
      feature.setStyle(style);
      this.vectorSource.addFeature(feature);
    },
    /**
     * adds closure to data so it can be listed in the window
     */
    async addClosureToClusterWKT(closure) {
      let maxHP = closure.cl_max_hp;

      this.clusterToolWKT.push({
        type: "Closure",
        uuid: closure.cl_uuid,
        id: closure.cl_id,
        text_geom: closure.node.nd_text_geom,
        endpoint: "closures",
        maxHP: maxHP,
        hover: false,
        label: closure.cl_label,
        layerName: "fc_closure"
      });
    },
    /**
     * @param data - Geo Json
     *
     * uses geo json to draw point in map
     */
    addPathwayLineHighlight(data) {
      let pathwaysJSON = data.pw_geo_json;

      let features = new GeoJSON().readFeatures(pathwaysJSON, {
        featureProjection: "EPSG:3857"
      });
      let feature = features[0];
      feature.setStyle(
        new Style({
          stroke: new Stroke({ color: "#bada55", width: 3 })
        })
      );
      this.vectorSource.addFeature(feature);
    },
    /**
     * clears data
     */
    clearDataSaveCluster() {
      this.dataSaveCluster = {
        initial_closure: 2,
        end_closure: 1,
        start_closure: null
      };
    },
    /**
     * opends cable form and emits data to store so when user saves the form it sends the microrouting request
     */
    saveCluster() {
      this.$emit("openForm", "fc_cable", "create");
      this.$store.dispatch("setClusterToolData", this.dataSaveCluster);
    }
  }
};
</script>
<style scoped>
.cluster-objects-div {
  padding: 5px 10px;
  min-height: 130px;
}
input:invalid,
textarea:invalid {
  border: 1px solid var(--red);
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectWindow/ClusterTool/ClusterToolWindow.vue